<template>
  <div class="n-header">
    <!-- 导航层 -->
    <div class="n-n">
      <div class="container">
        <!-- logo -->
        <div class="n-logo">
          <a href="/" style="color: #333">
            <h2>北京质子游戏科技有限公司</h2>
          </a>
        </div>
        <!-- 导航 -->
        <div class="n-list">
          <a href="/" class="animation active">网站首页</a>
          <a href="javascript:;" @click="goAc1()">付费资讯</a>
          <!-- <a href="javascript:;" @click="goAc2()">独家资讯</a> -->
          <!-- <a href="javascript:;" @click="goAc3()">研究报告</a> -->
          <!-- <a href="javascript:;" @click="goAc4()">互联网</a> -->
          <!-- <a href="javascript:;" @click="goAc5()">技巧中心</a> -->
          <!-- <a href="javascript:;" @click="goAc6()">手机应用</a> -->

          <a href="javascript:;" @click="goInfo()">关于我们</a>
          <a href="/Privacy.html" target="_blank">隐私协议</a>
          <!-- <a href="javascript:;" @click="gopay()">会员中心</a> -->
          <a href="javascript:;" @click="goXy()">用户协议</a>

          <a href="javascript:;" @click="goLogin()" v-show="this.LoggedShow">登录 / 注册</a>
          <!-- <a href="javascript:;" @click="goLogin()" v-show="this.LoggedShow">用户注册</a> -->
          <a href="javascript:;" v-show="!this.LoggedShow" v-text="this.nv_user.Username"></a>
          <a href="javascript:;" @click="tolg()" v-show="!this.LoggedShow">退出登录</a>
        </div>

        <!-- 搜索部分 -->
        <div class="search">
          <form method="get">
            <button type="submit" class="submit" value="搜索"><i class="iconfont icon-sousuo"></i></button>
            <input type="text" name="keyword" placeholder="搜索关键词">
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
      k: this.$route.query.k,
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      if (this.k) {
        window.localStorage.setItem("state", "10");
        window.localStorage.removeItem("k");
        this.$router.push("/");
        location.reload();
      } else {
        window.localStorage.setItem("state", "10");
        this.$router.push("/");
        location.reload();
      }
    },
    // 关于我们跳转
    goInfo() {
      this.$router.push("/info");
    },
    // 用户协议跳转
    goXy() {
      this.$router.push("/xy");
    },
    // 传统软件
    goAc1() {
      this.$router.push("/ac1");
    },
    // 互联网
    goAc2() {
      this.$router.push("/ac2");
    },
    // 研究报告
    goAc3() {
      this.$router.push("/ac3");
    },
    // 独家资讯
    goAc4() {
      this.$router.push("/ac4");
    },
    // 业界资讯
    goAc5() {
      this.$router.push("/ac5");
    },
    // 手机应用
    goAc6() {
      this.$router.push("/ac6");
    },
    // 手机应用
    gopay() {
      this.$router.push("/pay");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.n-header {
  position: relative;
  width: 100%;
  z-index: 20;
  margin-bottom: 80px;
  background: #e4eaf6;

  // 导航层
  .n-n {
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 21;
    backdrop-filter: blur(20px);
    background: linear-gradient(180deg, hsla(0, 0%, 100%, .36), hsla(0, 0%, 100%, .2));
    border-radius: 20px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);

    // margin-bottom: 80px;
    .container {
      height: 100%;
      @include flex();

      // logo
      .n-logo {
        width: 234px;
        height: 100%;
        display: flex;
        align-items: center;

        h2 {
          font-size: 16px;
          // font-weight: 400;
          // line-height: 80px;
        }

        img {
          // width: 200px;
          // height: 60px;
        }
      }

      // 导航
      .n-list {
        // width: 400px;
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;

        @keyframes text-background-animation {
          0% {
            background-position: 20% 0;
          }

          100% {
            background-position: -120% 0;
          }
        }

        .animation {
          background-image: -webkit-linear-gradient(-30deg, #23bea6, #f55668 30%, #ed3ace 70%, #0a2ddf);
          -webkit-text-fill-color: transparent;
          -webkit-background-clip: text;
          -webkit-background-size: 200% 100%;
          -webkit-animation: text-background-animation 2s infinite linear;
        }

        a {
          font-size: 18px;
          margin: 0 15px;
          display: inline-block;
          text-align: center;
          //   background-color: $colorZ;
          transition: all 0.2s;
          color: #333;

          &.active {
            color: #222;
            transition: all .2s ease;
          }

          &:hover {
            color: #00BDD7;
            transition: all .2s ease;
            text-decoration: none;
          }
        }
      }

      // 联系我们
      .n-phone {
        height: 100%;
        display: flex;
        align-items: center;

        h2 {
          font-size: 14px;
          color: $colorZ;
        }

        span {
          font-size: 18px;
          cursor: pointer;
          transition: all 0.2s;

          &:hover {
            color: $colorZ;
          }
        }
      }

      .search {
        float: right;
        margin-top: 8px;

        form {
          width: 190px;
          height: 40px;
          line-height: 40px;
          color: #ddd;

          button {
            background: #fff;
            float: right;
            width: 19%;
            height: 42px;
            line-height: 42px;
            text-align: center;
            box-sizing: border-box;
            border: 1px solid #eee;
            cursor: pointer;
            border-left: 0;
            border-radius: 0;
            box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
            border-radius: 50px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }

          input {
            text-indent: 10px;
            float: right;
            border: 1px solid #f1f1f1;
            height: 40px;
            line-height: 40px;
            width: 53.2%;
            background: #fff;
            color: #868686;
            transition: all .5s cubic-bezier(.215, .61, .355, 1);
            padding: 0;
            padding-left: 0px;
            padding-left: 0px;
            padding-left: 10px;
            border-radius: 0;
            box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
            border-radius: 50px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            &:hover {
              width: 73.2%;
              border-radius: 50px;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            }
          }
        }
      }
    }
  }
}
</style>
